import { parseISO, subDays, addDays } from 'date-fns';

// #region QA TESTING ONLY — delete this entire region before going to prod
// import { addMinutes, subMinutes } from 'date-fns';
// const QA_ANCHOR_KEY = 'qa_goLiveAnchor';
// export const setQAGoLiveAnchor = (): void => {
//   localStorage.removeItem(QA_ANCHOR_KEY);
//   localStorage.setItem(QA_ANCHOR_KEY, addMinutes(new Date(), 30).toISOString());
// };
// const getQADynamicText = (now: Date): string => {
//   const stored = localStorage.getItem(QA_ANCHOR_KEY);
//   const goLive = stored ? new Date(stored) : addMinutes(now, 30);
//   const hypercareStart = subMinutes(goLive, 15);
//   if (now > goLive) {
//     return 'Thank you for submitting your go-live date. Our records have been updated.';
//   }
//   if (now >= hypercareStart) {
//     return 'Thank you for submitting your go-live date. Contact Support if you require assistance.';
//   }
//   return 'Thank you for submitting your go-live date. Our Support team has been notified.';
// };
// #endregion QA TESTING ONLY

export const getGoLiveDynamicText = (goLiveDateStr: string): string => {
  const now = new Date();

  // TODO: QA TESTING ONLY — remove this block before going to prod
  // if (goLiveDateStr.length === 10) {
  //   return getQADynamicText(now);
  // }
  // end QA block

  const goLive = parseISO(goLiveDateStr);
  const postGoLive = addDays(goLive, 1); // post go-live starts the day after
  const hypercareStart = subDays(goLive, 30);

  if (now >= postGoLive) {
    return 'Thank you for submitting your go-live date. Our records have been updated.';
  }
  if (now >= hypercareStart) {
    return 'Thank you for submitting your go-live date. Contact Support if you require assistance.';
  }
  return 'Thank you for submitting your go-live date. Our Support team has been notified.';
};
